"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var header__deskop_user_menu_1 = __importDefault(require("./header--deskop-user-menu"));
var HeaderDesktopTop = function (props) {
    return (React.createElement("div", { className: "ds-header-top" },
        React.createElement("div", { className: "width-max" },
            React.createElement("div", { className: "ds-table w-100 table-header" },
                React.createElement("div", { className: "ds-menu-hamburger " + (props.menuMobile ? 'open' : ''), onClick: props.toggleMenuMobile },
                    React.createElement("span", null),
                    React.createElement("span", null),
                    React.createElement("span", null)),
                React.createElement("div", { className: "ds-cell vertical-align-middle ds-logo-cell ds-cell-min" },
                    !!props.homeLink && (React.createElement(react_router_dom_1.NavLink, { to: { pathname: props.homeLink }, exact: true },
                        React.createElement("div", { className: "ds-logo" },
                            React.createElement("img", { src: props.logo, alt: "" })))),
                    !props.homeLink && (React.createElement("div", { className: "ds-logo" },
                        React.createElement("img", { src: props.logo, alt: "" })))),
                React.createElement("div", { className: "ds-cell text-right vertical-align-middle" }, props.contentBeforeUser),
                React.createElement("div", { className: "ds-cell text-right vertical-align-middle ds-user-cell" },
                    React.createElement(header__deskop_user_menu_1.default, __assign({}, props)))))));
};
exports.default = HeaderDesktopTop;
//# sourceMappingURL=header--deskop-top.js.map